import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { NavbarComponent, FooterComponent } from '@/shared/components';

interface Notification {
  id: number;
  tipo: string;
  titulo: string;
  mensagem: string;
  data: string;
  hora: string;
  lida: boolean;
  cor: string;
  corFundo: string;
  corBorda: string;
  link: string;
}

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule, RouterLink, NavbarComponent, FooterComponent],
  templateUrl: './notifications.component.html',
})
export class NotificationsComponent {
  notificacoes: Notification[] = [
    // {
    //   id: 1,
    //   tipo: 'pagamento',
    //   titulo: 'Pagamento Confirmado',
    //   mensagem:
    //     'O pagamento da taxa de inscrição do EDITAL Nº 2437 - DIREITO foi confirmado com sucesso. Seu cartão de confirmação está disponível.',
    //   data: '22 Dez 2025',
    //   hora: '14:30',
    //   lida: false,
    //   cor: 'text-emerald-600',
    //   corFundo: 'bg-emerald-50',
    //   corBorda: 'border-emerald-600',
    //   link: '/portal/candidato',
    // },
    // {
    //   id: 2,
    //   tipo: 'alerta',
    //   titulo: 'Prazo de Pagamento',
    //   mensagem:
    //     'O prazo para pagamento da taxa de inscrição do EDITAL Nº 2206 - SELETIVO TI SÊNIOR vence em 3 dias. Não perca o prazo!',
    //   data: '22 Dez 2025',
    //   hora: '09:15',
    //   lida: false,
    //   cor: 'text-amber-500',
    //   corFundo: 'bg-amber-50',
    //   corBorda: 'border-amber-500',
    //   link: '/portal/candidato',
    // },
    // {
    //   id: 3,
    //   tipo: 'info',
    //   titulo: 'Novo Edital Publicado',
    //   mensagem:
    //     'Foi publicado o EDITAL Nº 2501 - MATEMÁTICA com 35 vagas. Inscrições abertas até 15 de janeiro de 2026.',
    //   data: '21 Dez 2025',
    //   hora: '16:00',
    //   lida: false,
    //   cor: 'text-blue-600',
    //   corFundo: 'bg-blue-50',
    //   corBorda: 'border-blue-600',
    //   link: '/portal',
    // },
    // {
    //   id: 4,
    //   tipo: 'documento',
    //   titulo: 'Documentação Complementar Disponível',
    //   mensagem:
    //     'Foi disponibilizada a retificação do edital EDITAL Nº 2437 - DIREITO. Verifique as alterações em seu edital.',
    //   data: '20 Dez 2025',
    //   hora: '11:20',
    //   lida: true,
    //   cor: 'text-gray-600',
    //   corFundo: 'bg-gray-50',
    //   corBorda: 'border-gray-600',
    //   link: '/portal',
    // },
    // {
    //   id: 5,
    //   tipo: 'data',
    //   titulo: 'Local de Prova Divulgado',
    //   mensagem:
    //     'O local de prova do EDITAL Nº 2437 - DIREITO foi divulgado. Sua prova será no Campus Norte - Bloco C, Sala 105.',
    //   data: '19 Dez 2025',
    //   hora: '10:00',
    //   lida: true,
    //   cor: 'text-purple-600',
    //   corFundo: 'bg-purple-50',
    //   corBorda: 'border-purple-600',
    //   link: '/portal/candidato',
    // },
    // {
    //   id: 6,
    //   tipo: 'inscricao',
    //   titulo: 'Inscrição Confirmada',
    //   mensagem:
    //     'Sua inscrição no EDITAL Nº 2206 - SELETIVO TI SÊNIOR foi confirmada. Número de inscrição: 2025-00847.',
    //   data: '15 Dez 2025',
    //   hora: '15:45',
    //   lida: true,
    //   cor: 'text-green-600',
    //   corFundo: 'bg-green-50',
    //   corBorda: 'border-green-600',
    //   link: '/portal/candidato',
    // },
  ];

  get naoLidas(): number {
    return this.notificacoes.filter(n => !n.lida).length;
  }

  marcarTodasComoLidas() {
    this.notificacoes.forEach(n => n.lida = true);
  }

  marcarComoLida(notificacao: Notification, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    notificacao.lida = true;
  }

  mostrarSeparador(index: number): boolean {
    if (index >= this.notificacoes.length - 1) return false;
    const atual = this.notificacoes[index];
    const proxima = this.notificacoes[index + 1];
    return !atual.lida && proxima.lida;
  }

  getIcone(tipo: string): string {
    const icones: { [key: string]: string } = {
      'pagamento': 'check-circle',
      'alerta': 'alert-circle',
      'info': 'info',
      'documento': 'file-text',
      'data': 'calendar',
      'inscricao': 'check-circle'
    };
    return icones[tipo] || 'info';
  }
}
